import { useCallback, useEffect, useState } from 'react'
import { latestRelease } from './release-notes'

const STORAGE_KEY = 'saip.whatsnew.v1'

/** Zuletzt gesehene Version, oder null (nie gesehen / Speicher gesperrt). */
export function lastSeenRelease(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY)
  } catch {
    // Task pane mit gesperrten Websitedaten — dann eben jedes Mal.
    return null
  }
}

export function markReleaseSeen(version: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, version)
  } catch {
    // Nichts zu tun; das Fenster ist für diese Sitzung trotzdem zu.
  }
}

export interface UseWhatsNew {
  /** Soll das Fenster gerade offen sein? */
  open: boolean
  /** Von Hand öffnen (z. B. aus den Einstellungen). */
  show: () => void
  /** Schließen und die aktuelle Version als gesehen vermerken. */
  dismiss: () => void
}

/**
 * Zeigt die Neuerungen einmal je Version. Der Vermerk fällt beim Schließen —
 * wer das Fenster nie zu Gesicht bekommt (Absturz, Neustart), sieht es wieder.
 */
export function useWhatsNew(): UseWhatsNew {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!latestRelease) return
    if (lastSeenRelease() !== latestRelease.version) setOpen(true)
  }, [])

  const show = useCallback(() => setOpen(true), [])
  const dismiss = useCallback(() => {
    setOpen(false)
    if (latestRelease) markReleaseSeen(latestRelease.version)
  }, [])

  return { open, show, dismiss }
}
